import styled from 'styled-components';

import $Icon from 'components/Icon';
import {commonPalette} from 'styles/palette';
import {borderRadius} from 'styles/vars';

export const FormSelect = styled.div`
  background: ${commonPalette.darkerGray};
  border-radius: ${p => borderRadius[p.device]}px;
  position: relative;
`;

export const Chevron = styled($Icon).attrs({
  name: 'chevron-down'
})`
  pointer-events: none;
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
`;

export const Select = styled.select`
  appearance: none;
  background: none;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: ${p => borderRadius[p.device]}px;
  display: block;
  font-family: inherit;
  font-size: inherit;
  height: 3rem;
  outline: none;
  padding: 0 3rem 0 1rem;
  position: relative;
  width: 100%;

  &:focus,
  &:hover {
    border-color: rgba(0, 0, 0, 0.4);
  }

  &:focus {
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
  }

  &::-ms-expand {
    display: none;
  }
`;
